import styled from '@emotion/styled'
import { calcRem, breakpoint, themedValue } from '../../../__styling'
import { tokens } from '@news-mono/design-tokens'
import { WebLink } from '@news-mono/web-common'

export const LogoContainer = styled('div')(({ theme }) => ({
    alignSelf: 'center',
    padding: calcRem(16, 24),
    paddingTop: calcRem(24),
    paddingBottom: calcRem(24),
    margin: 0, //remove margin added by H2 wrapping

    [breakpoint('xs')]: {
        alignSelf: 'auto',
        paddingTop: themedValue(theme, {
            thenightly: calcRem(41),
            thewest: calcRem(41),
            sevennews: undefined,
            fallback: calcRem(41),
        }),
        paddingBottom: calcRem(32),
        borderBottom: 'none',
    },
    [breakpoint('lg')]: {
        paddingLeft: 0,
    },
}))

export const DividerContainer = styled('div')(() => ({
    borderBottom: `1px solid ${tokens.thenightly.colors.borders.secondary}`,
    display: 'flex',
    flexDirection: 'column',
    [breakpoint('xs')]: {
        borderBottom: 'none',
    },
}))

export const StyledPicture = styled.picture({
    display: 'flex',
    justifyContent: 'center',

    '& img': {
        width: '100%',
        maxWidth: calcRem(443),
    },
})

export const LogoLink = styled(WebLink)({
    display: 'flex',
    height: 'fit-content',
})
